module.exports = __webpack_public_path__ + "static/dinamica_maquinaria-28213fdb6cd1d49e3e746f02e1924698.jpg";